module.exports = __webpack_public_path__ + "media/src/components/shared/general/img/mobileBrancdLogo-5c9c61dcb39e4cd18f12fb17a0e92883.png";